import { render, staticRenderFns } from "./HeaderContact.vue?vue&type=template&id=a156c9d6"
import script from "./HeaderContact.vue?vue&type=script&lang=js"
export * from "./HeaderContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports